import { CalculatorPages } from '@pages/CalculatorPage/types';
import { ApplicationFormPageEnum } from '../pages/ApplicationFormPage/types';

const affordabilityLocalStorageKey = 'affordability';
const affordabilityLastPageKey = 'affordabilityLastPage';

export const setLocalStorageItem = (key: string, value: string) => {
  return localStorage.setItem(key, value);
};

export const getParsedLocalStorageItem = (key: string) => {
  const result = localStorage.getItem(key);

  return result ? JSON.parse(result) : null;
};

export const removeStorageItem = (key: string) => localStorage.removeItem(key);

export const setAffordabilityLocalStorageItem = (partOfFormKey: string, partOfForm: Record<string, any>) => {
  const affordabilityData = getParsedLocalStorageItem(affordabilityLocalStorageKey) || {};

  setLocalStorageItem(
    affordabilityLocalStorageKey,
    JSON.stringify({ ...affordabilityData, [partOfFormKey]: partOfForm }),
  );
};

export const saveAffordabilityFormToLocalStorage = (form: Record<string, any>) =>
  setLocalStorageItem(affordabilityLocalStorageKey, JSON.stringify(form));

export const getAffordabilityLocalStorageItem = () => getParsedLocalStorageItem(affordabilityLocalStorageKey);

export const setLastAffordabilityCalcPage = (page: CalculatorPages) =>
  setLocalStorageItem(affordabilityLastPageKey, page);

export const getLastAffordabilityCalcPage = () => localStorage.getItem(affordabilityLastPageKey);

export const clearAffordabilityCalculatorSavedData = () => {
  removeStorageItem(affordabilityLocalStorageKey);
  removeStorageItem(affordabilityLastPageKey);
};

export const setApplicationRoutes = (routes: string[]) => {
  setLocalStorageItem('applicationRoutes', JSON.stringify(routes));
};

export const addRouteToApplicationRoutes = (currentBrowserLocation = window.location.pathname) => {
  if (
    currentBrowserLocation.includes('/application/edit') &&
    !currentBrowserLocation.includes(ApplicationFormPageEnum.CRITERIA)
  ) {
    const routes = getParsedLocalStorageItem('applicationRoutes') || [];
    const currentBrowserLocationWithSearchParams = currentBrowserLocation + window.location.search;

    if (routes.includes(currentBrowserLocationWithSearchParams)) return;
    routes.push(currentBrowserLocationWithSearchParams);

    setLocalStorageItem('applicationRoutes', JSON.stringify(routes));
  }
};

export const parseApplicationRoutesAndSaveToStorage = (applicationInProgress: Record<string, any>) => {
  const routes = Object.keys(applicationInProgress).filter(key => key.includes('application'));

  setApplicationRoutes(routes);
};

export const getApplicationProgressRoutes = () => {
  const routes = getParsedLocalStorageItem('applicationRoutes');

  return routes || [];
};

export const getLasestApplicationProgressRoute = () => {
  const routes = getParsedLocalStorageItem('applicationRoutes') || [];

  return routes[routes.length - 1] || `${window.location.pathname}?section=${ApplicationFormPageEnum.CRITERIA}`;
};

export const getPreviusApplicationProgressRoute = (currentBrowserLocation = window.location.pathname) => {
  const routes = getApplicationProgressRoutes();
  const currentBrowserLocationWithSearchParams = currentBrowserLocation + window.location.search;
  const currentRouteIndex = routes.indexOf(currentBrowserLocationWithSearchParams);

  return routes[currentRouteIndex - 1] || `${window.location.pathname}?section=${ApplicationFormPageEnum.CRITERIA}`;
};

export const removeRoutesFromApplicationRoutes = () => {
  setLocalStorageItem('applicationRoutes', JSON.stringify([]));
};

export const removeApplicationProgressRoute = () => {
  const routes = getApplicationProgressRoutes();
  routes.pop();

  setLocalStorageItem('applicationRoutes', JSON.stringify(routes));
};
